<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back @back="returnBack()" :title="['互动广场']" :subTitle="activityData.name" style="padding-bottom: 0"></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px">云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip>
        <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="150px">
          <!-- 基本信息 -->
          <informationForm @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember" :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime" :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime" :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected" ref="informationForm" v-model="ruleForm" :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum" :activityId="83" :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item label="条件设置:" required>
              <div class="rule_box" style="margin-top:0;width: 950px;">
                <div class="rule_box_middle">
                  <el-form-item label="评价时间:" required>
                    <!-- <el-select
                      v-model="appraiseValue"
                      placeholder="请选择"
                      :disabled="isStart"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select> -->
                    <div class="my_select_time">
                      <el-date-picker prefix-icon="no_icon" v-model="ruleForm.startCommentTime" type="datetime"
                        placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px" default-time="00:00:00" class="time1"
                        @change="orderChange" :clearable="false" :picker-options="pickerOrderStart">
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker prefix-icon="no_icon" v-model="ruleForm.endCommentTime" type="datetime"
                        placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px" default-time="23:59:59" class="time2"
                        @change="orderChange" :clearable="false" :picker-options="pickerOrderEnd">
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="clearOrderTime()"></i>
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                        class="date_icon2" />
                    </div>
                  </el-form-item>
                  <el-form-item label="参与商品:" required class="zindexBox">
                    <el-radio v-model="ruleForm.filterType" label="0">全部商品</el-radio>
                    <el-radio v-model="ruleForm.filterType" label="1">指定商品</el-radio>
                    <jd-button :class="[{ 'global-view-btn': backgroundOpacity }]"
                      :disabled="ruleForm.filterType == 0 || (backgroundOpacity && !isSave)"
                      @click="exposureProductsFiter">
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </jd-button>
                  </el-form-item>
                  <el-form-item label="评星设置:" required>
                    <el-checkbox-group v-model="scores">
                      <el-checkbox v-for="item in labelVal" :label="item.value" :key="item.value">{{
                        item.name }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="评价字数:">
                    评价至少
                    <el-input v-model="ruleForm.wordNum"
                      @input.native="ruleForm.wordNum = checkputn($event)" style="width:140px"
                      placeholder="请输入"></el-input>
                    个字（空或0表示不限制）
                  </el-form-item>
                  <el-form-item label="评价图片:" required>
                    包含至少
                    <el-input v-model="ruleForm.imgNum"
                      @input.native="ruleForm.imgNum = checkputn($event, '1')" style="width:140px"
                      placeholder="请输入"></el-input>
                    张图片（<span style="color:rgb(245, 108, 108)">评价图片该配置为活动参与必选门槛;用户评价内容包含图片才可参与本活动</span>）
                  </el-form-item>
                  <el-form-item label="评价视频:">
                    包含至少
                    <el-input :disabled="ruleForm.imgNum == 9" v-model="ruleForm.videoNum"
                      @input.native="ruleForm.videoNum = checkputn($event, '2')" style="width:140px"
                      placeholder="请输入"></el-input>
                    段视频（空或0表示不限制，不超过1）
                    <div style="color: rgb(245, 108, 108);">
                      注意：图片数量+视频数量总数必须{{ '=<' }}9 </div>
                  </el-form-item>
                  <el-form-item label="过滤条件:">
                    <el-checkbox v-model="ruleForm.isCommentFilter">评价内容包含</el-checkbox>&nbsp;
                    <el-input v-model="ruleForm.commentFilter" @input.native="
                      ruleForm.commentFilter = ruleForm.commentFilter.replace(
                        /，/g,
                        ','
                      )
                      " style="width:250px" placeholder="多个关键词之间用英文“,”隔开"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否开启预留地址:">
              <el-switch v-model="ruleDTO.isPreEnter" :disabled="true">
              </el-switch>
              <span class="openTip">开启后，用户报名成功时将引导用户预留收货地址。不开启则在开榜后用户领取奖品时再引导填写地址</span>
            </el-form-item>
            <el-form-item label="晒图内容是否需要审核:" required>
              <el-checkbox v-model="isNeedAudit" :disabled="true">
                需要审核
              </el-checkbox>
              <jd-tip>
                <div>1、用户提交的晒单内容需商家人工审核通过才可对外展示、开放点赞；</div>
                <div style="color: rgb(245, 108, 108);">2、不可取消此配置，通过人工审核可提前拦截违规、不当言论，避免内容违规导致小程序账号受处罚风险；</div>
                <div>3、商家前往【活动数据 - 晒图记录】执行批量审核操作。</div>
              </jd-tip>
            </el-form-item>

            <el-form-item label="评价限制:">
              <el-radio-group v-model="ruleForm.isCommentLimit" :disabled="isStart">
                <el-radio label="0">不限制</el-radio>
                <el-radio label="1">同一条评价仅能参与同类型至多 1 个活动</el-radio>
              </el-radio-group>
              <div style="color: rgb(245, 108, 108);">注：用户历史使用过的同一评价，先参与其他晒图PK活动后，不可再使用此评价参与本活动</div>
            </el-form-item>

            <el-form-item label="排行榜开奖时间:" required>
              <el-date-picker v-model="ruleForm.rankedOpenTiming" type="datetime"
                placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px" default-time="00:00:00"
                :clearable="true" :disabled="isStart">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开奖方式:" required>
              <el-radio-group :disabled="isStart" v-model="ruleForm.rankedOpenType" @change="changeOpenType">
                <el-radio label="0">按点赞排名自动开奖</el-radio>
                <el-radio label="1">商家手动审核开奖</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.rankedOpenType == '0'" label="入榜限制:" required>
              <div>
                <span>至少收集</span>
                <el-input :disabled="isStart" v-model="ruleForm.rankedLimit" placeholder="请输入" style="width:140px;margin: 0 8px;"></el-input>
                <span>点赞数，才能进入榜单领奖</span>
              </div>
              <jd-tip style="margin-top: 8px;">
                例如输入20，则如果排名第一的用户被点赞10次也无法获得奖品
              </jd-tip>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="奖品设置：">
              <newPrizeTable :prizeList.sync="prizeSetting" :isIndex="isIndex" :isDisabled="activityData.isStart"
                :isDisabledTotal="isDisabledTotal" :tableInfo="tableInfo" :valueRow="valueRow" :isShowUpLoadBtn="true"
                :actType="83" :isShowMoveBtn="isShowMoveBtn" :actEndTime="ruleForm.endTime">
                <!-- 作用域插槽实现额外字段的输入 -->
                <template #rankHeader>
                  <span v-if="ruleForm.rankedOpenType == 0">排名设置</span>
                  <span v-if="ruleForm.rankedOpenType == 1">榜单条件</span>
                </template>
                <template #rankTypeName="{ scopeRow, scopeIndex }">
                  <div class="flex-r"  v-if="ruleForm.rankedOpenType == 0">
                    <el-select v-model="scopeRow.scoreRankWinConditionDTO.winType" placeholder="请选择" class="w120"
                      :disabled="activityData.isStart" @change="handleWinTypeChange(scopeRow, scopeIndex)">
                      <el-option label="排名区间" :value="0" />
                      <el-option label="指定名次" :value="1" />
                    </el-select>
                    <div class="flex-r ml8" v-if="scopeRow.scoreRankWinConditionDTO.winType === 0">
                      <el-input v-model="scopeRow.scoreRankWinConditionDTO.rankStart" placeholder="请输入" class="w80"
                        :disabled="activityData.isStart" @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankStart')
                        " @change="rankedChange(scopeRow, scopeIndex)" />
                      <span class="mlr8">~</span>
                      <el-input v-model="scopeRow.scoreRankWinConditionDTO.rankEnd" placeholder="请输入" class="w80"
                        :disabled="activityData.isStart" @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankEnd')
                        " @change="rankedChange(scopeRow, scopeIndex)" />
                    </div>
                    <div class="ml8" v-else>
                      <el-input v-model="scopeRow.scoreRankWinConditionDTO.rankNum" placeholder="请输入"
                        @input="
                          (val) => filterRankNumber(val, scopeRow, 'rankNum')
                        "
                        @change="rankedChange(scopeRow, scopeIndex)"
                        :disabled="activityData.isStart" />
                    </div>
                  </div>
                  <div class="flex-r"  v-if="ruleForm.rankedOpenType == 1">
                    <el-input v-model="scopeRow.scoreRankWinConditionDTO.rankedTitle" placeholder="请输入" class="w120"
                     show-word-limit maxlength="10" />
                  </div>
                </template>
              </newPrizeTable>
              <jd-button class="mt16" type="blue" :disabled="activityData.isStart || prizeSetting.length >= limitNum
                " @click="addPrizeSetting">+增加排名（{{ prizeSetting.length }}/{{ limitNum }}）</jd-button>
              <div style="margin-top:8px">
                <jd-tip>
                  至少配置1个排行奖品，至多配置20个榜单奖品
                </jd-tip>
              </div>
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings isShowShopName isShowMoreSet :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON" :isNeedSetBG="true" :giftList="giftList"
            :templateId="templateId" :isShowDesignNumber="false" previewKey="url" templatekey="imageUrl"
            :widthNumber="750" :heightNumber="2500" :isCustomPreview="true" :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn//hd/images/13315956_71227bef6a294fabbad28ae334589090.png"
            themeTitle="主题" :defaultRgb="currrentRgb" v-model="customerPaperwork" @selectTemplate="selectTemplate">
            <template #customPreview>
              <showPkPreviews :ruleForm="ruleForm" :ruleDTO="ruleDTO" :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork" :templateObj="templateObj" :productList="prizeSetting" />
            </template>
            <template #otherSet>
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <btnSet :customerData="customerPaperwork" bgKey="url2" colorKey="btnColor" :pw="580" :ph="98"
                    labelText="按钮背景图" :backgroundOpacity="backgroundOpacity" :resetColor="currrentRgb2" />
                </div>
              </el-form-item>
              <el-form-item label="奖品剩余库存：" label-width="155px">
                <el-radio-group v-model="customerPaperwork.showStock">
                  <el-radio :label="false">不显示</el-radio>
                  <el-radio :label="true"
                    >显示（C端活动页奖品显示剩余库存）</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="实物奖品价值：" label-width="155px">
                <el-radio-group v-model="customerPaperwork.showPrice">
                  <el-radio :label="false">不显示</el-radio>
                  <el-radio :label="true"
                    >显示（开启后C端活动页实物奖品显示奖品价值）</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </template>
          </activityPageSettings>
          <!-- <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item> -->
          <exposureList :defaultExposureSwitch.sync="ruleForm.isExposureItem" v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity" :isLimit="true"></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition" v-model="ruleForm.ruleDescription" @generateRule="generateRule"
            :activityData="activityData" :valueRow="valueRow"></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button v-if="localStepNum != 0" style="margin-right: 8px" @click="clickLocalStep()">{{ backgroundOpacity ?
        "返回列表"
        : "返回上一步" }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick>保存设置</jd-button>
      </template>
    </div>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor v-if="selectGoodsStateFilter" ref="selectGoFilter" :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter" :selectGoods="selectGoodsFilterArr" :moduleType="true" :skuSearch="true"
      :xianz="false" :disabled="backgroundOpacity" isInteract></selectGoodsMonitor>

    <!-- 保存设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px" v-loading="saveLoading">确
          定</jd-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveOrUpdateShowImageGift,
  getShowImageGiftDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import showPkPreviews from "./components/newActPreviews/showPkPreviews.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import {
  useInputTaskData,
  useOutputTaskData,
  useCondition,
} from "./components/commDataHook/useTaskData.js";
import {
  useOutputBasicInformation,
  useInputBasicInformation,
  useUpdateBasicInformation,
  useValidateBasicInformation,
  useValidatePrizeInformation,
  useValidateActEndInfomation,
  initFrom,
  setBasicInformation
} from "./components/commDataHook/useBasicInformation.js";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    showPkPreviews,
    taskComponent,
    newPrizeTable,
    btnSet,
    selectGoodsMonitor,
    draggable,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => { },
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isNeedAudit: true,
      isDraggingFilter: false,
      selectGoodsStateFilter: false,
      isStart: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      mainImagelistFilter: [],
      draggingIdFilter: [],
      scores: ["5"],
      labelVal: [
        {
          name: "一星",
          value: "1",
        },
        {
          name: "二星",
          value: "2",
        },
        {
          name: "三星",
          value: "3",
        },
        {
          name: "四星",
          value: "4",
        },
        {
          name: "五星",
          value: "5",
        },
      ],

      appraiseValue: "1",
      options: [
        {
          value: "1",
          label: "近7天完成的评价",
        },
        {
          value: "2",
          label: "近15天完成的评价",
        },
        {
          value: "3",
          label: "近1个月完成的评价",
        },
        {
          value: "4",
          label: "近2个月完成的评价",
        },
        {
          value: "0",
          label: "自定义",
        },
      ],
      jdCrm: {
        endTime: "",
      },
      isDisabledTotal: true,
      limitNum: 20,
      isIndex: false,
      isShowCustom: true,
      mainText: "分数",
      otherUnit: "分",
      unit: "",
      extraText:
        "*添加任务后可在任务列表输入自定义任务名称和任务描述，不输入则使用默认名称和描述",
      hasSelectGoods: [],
      isShowUnit: false,
      taskLevelList: [],
      isShowMoveBtn: true,
      prizeSetting: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          scoreRankWinConditionDTO: {
            winType: 0, //排名类型
            rankStart: "", //排名开始
            rankEnd: "", //排名结束
            rankNum: "", //指定名次
            rankedTitle: "", //榜单名称
          },
        },
      ], //奖品设置
      taskDataList: [], //任务列表
      taskOrderList: [],
      isLimit: true,
      tableInfo: [
        {
          label: "排名设置",
          prop: "scoreRankWinConditionDTO",
          slot: "rankTypeSlot",
          slotName: "rankTypeName",
          slotHead: "rankHeader",
          width: 320,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          width: 160,
        },
        {
          label: "值",
          prop: "price",
          width: 130,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          width: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
          width: 180,
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
          width: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 300,
        },
      ],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/晒图PK.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      customerPaperwork: {
        title: "晒图pk",
        desc: "分享种草好物 邀请好友点赞得好礼",
        titleColor: "#ffffff", //主题字体颜色
        url2: "", //选中导航背景图
        url3: "", //按钮背景图
        layout: 1, //布局类型
        // selectColor: "#ffffff", //选中导航字体颜色
        // unSelectBgColor: "#ffffff", //未选中导航背景颜色
        // unSelectColor: "#000000", //未选中导航字体颜色
        // navOpacity: 100, //导航背景不透明度
        btnColor: "#ffffff", //按钮字体颜色

        showStock: false, //是否显示库存数量
        showPrice: false, //是否显示奖品价值
        shopNameType: 0
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)


        startCommentTime: "",
        endCommentTime: "",
        filterType: "0", // 0-不限, 1-指定时间
        wordNum: "", // 评价内容字数
        imgNum: "", // 评价图片图片数
        videoNum: "", // 评价视频视频数
        isCommentFilter: false, // 是否开启评价筛选
        commentFilter: "", // 评价内容限制，多个用英文逗号隔开
        isCommentLimit: "0", // 评价限制
        rankedOpenTiming: "", // 开奖时间类型
        rankedOpenType: "0", // 开奖方式类型
        rankedLimit: "", // 入榜限制
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            // return time.getTime() > new Date(this.ruleForm.orderEndTime).getTime();
            const day = 24 * 60 * 60 * 1000 * 60;
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime() - day
            );
          } else {
          }
        },
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startCommentTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.startCommentTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.startCommentTime).getTime()
              );
            }
          } else {
          }
        },
      },
      sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_3305da88a03947b283e2766d0b531132.png",
      ruleDTO: {
        participateType: 1,
        participateTimeStart: "",
        participateTimeEnd: "",
        rankPrizeTime: "",
        prizeConfig: 0,
        isPreEnter: false,
        customerPaperwork: "",
        cusTemplateJSON: "",
        cusType: 0, //新老客类型
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_3305da88a03947b283e2766d0b531132.png",
        openCardStartTime: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
            new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
      joinTimePickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.ruleForm.startTime
              ? time.getTime() <
              new Date(this.ruleForm.startTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleForm.endTime
              ? time.getTime() > new Date(this.ruleForm.endTime).valueOf()
              : false) ||
            (this.ruleDTO.participateTimeEnd
              ? time.getTime() >
              new Date(this.ruleDTO.participateTimeEnd).valueOf()
              : false) ||
            (this.ruleDTO.rankPrizeTime
              ? time.getTime() > new Date(this.ruleDTO.rankPrizeTime).valueOf()
              : false)
          );
        },
      },
      joinTimePickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.ruleForm.endTime
              ? time.getTime() >
              new Date(this.ruleForm.endTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleDTO.participateTimeStart
              ? time.getTime() <
              new Date(this.ruleDTO.participateTimeStart).valueOf() - 8.64e7
              : false) ||
            (this.ruleForm.startTime
              ? time.getTime() <
              new Date(this.ruleForm.startTime).valueOf() - 8.64e7
              : false) ||
            (this.ruleDTO.rankPrizeTime
              ? time.getTime() > new Date(this.ruleDTO.rankPrizeTime).valueOf()
              : false)
          );
        },
      },
      //开榜时间限制
      rankTimePicker: {
        disabledDate: (time) => {
          let start = this.activityStartTime
            ? new Date(this.activityStartTime).getTime() - 8.64e7
            : 0;
          // 结束时间限制为活动结束时间前24小时
          let end = this.activityEndTime
            ? new Date(this.activityEndTime).getTime() - 8.64e7
            : Infinity;
          let current = time.getTime();
          if (current > start && current <= end) {
            return false;
          } else {
            return true;
          }
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    // 开榜前是否禁用
    isDisabeldWin() {
      // 当前时间
      let currentTime = new Date().getTime();
      let flag = false;
      if (
        this.ruleDTO.rankPrizeTime &&
        this.compareTime(this.ruleDTO.rankPrizeTime) > currentTime
      ) {
        flag = false;
      } else {
        flag = this.activityData.isStart;
      }
      return flag;
    },
  },
  watch: {},
  created() {
    this.isStart = this.activityData.isStart ? true : false;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    useJdCrm(this);
    this.buriedPoint(1, "晒图pk", "互动管理", "互动活动");
  },

  methods: {
    // 开奖方式
    changeOpenType() {
      if (this.ruleForm.rankedOpenType == 0) {
        this.ruleDTO.isPreEnter = false;
        this.isDisabledTotal = true;
      }else{
        this.ruleDTO.isPreEnter = true;
        this.isDisabledTotal = false;
      }

      this.prizeSetting = this.prizeSetting.map((item) => {
        item.totalAmount = null;
        item.scoreRankWinConditionDTO.winType = 0;
        item.scoreRankWinConditionDTO.rankStart = "";
        item.scoreRankWinConditionDTO.rankEnd = "";
        item.scoreRankWinConditionDTO.rankNum = "";
        item.scoreRankWinConditionDTO.rankedTitle = "";
        return item;
      })
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 2 || e.target.value > 5) {
            e.target.value = "";
          }
        }
        return e.target.value
      } else {
        if (
          num.quantityTotal &&
          num.price &&
          num.totalAmount &&
          num.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...num,
            prizeCount: num.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    // 参与商品图片拖拽
    onEndFilter() {
      this.isDraggingFilter = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelistFilter.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingIdFilter = arr;
      });
    },
    // 参与商品删除
    delecFilter(index) {
      this.mainImagelistFilter.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      if (data) {
        this.itemListForFilter = [];
        this.mainImagelistFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          this.mainImagelistFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      // console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    clearOrderTime() {
      if (!this.isSave) return;
      if (this.isStart) return;
      this.ruleForm.startCommentTime = null;
      this.ruleForm.endCommentTime = null;
    },
    handleWinTypeChange(row, index) {
      row.scoreRankWinConditionDTO.rankStart = "";
      row.scoreRankWinConditionDTO.rankEnd = "";
      row.scoreRankWinConditionDTO.rankNum = "";
      row.scoreRankWinConditionDTO.rankedTitle = "";
    },
    syncJoinTime() {
      if (!this.ruleForm.startTime) {
        return this.$message.warning("请先选择活动开始时间");
      }
      if (!this.ruleDTO.rankPrizeTime) {
        return this.$message.warning("请先选择开榜时间");
      }
      this.ruleDTO.participateTimeStart = this.ruleForm.startTime;
      this.ruleDTO.participateTimeEnd = this.ruleDTO.rankPrizeTime;
    },
    compareTime(time) {
      return new Date(time).getTime();
    },
    clearShowRankTime() {
      this.ruleDTO.rankPrizeTime = "";
    },
    changeJoinType() {
      this.ruleDTO.participateTimeStart = "";
      this.ruleDTO.participateTimeEnd = "";
    },
    // 增加奖品设置
    addPrizeSetting() {
      if (this.prizeSetting.length >= this.limitNum) {
        return this.$message.warning(`最多只能添加${this.limitNum}个奖品`);
      }
      this.prizeSetting.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        scoreRankWinConditionDTO: {
          winType: 0, //排名类型
          rankStart: "", //排名开始
          rankEnd: "", //排名结束
          rankNum: "", //指定名次
          rankedTitle: "", //榜单名称
        },
      });
    },
    // 输入时只做数字过滤，不做大小比较，避免输入过程中被清空
    filterRankNumber(val, row, field) {
      let filtered = val.replace(/^0|[^\d]/g, "");
      let num = Number(filtered);
      if (num < 1) {
        filtered = "";
      }
      row.scoreRankWinConditionDTO[field] = filtered;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    rankedChange(item, index) {
      const condition = item.scoreRankWinConditionDTO;
      const rankStart = Number(condition.rankStart);
      const rankEnd = Number(condition.rankEnd);
      const rankNum = Number(condition.rankNum);

      let isValid = true;

      if (condition.winType === 0) {
        if (rankEnd && rankStart) {
          if (rankEnd <= rankStart) {
            this.$message.warning("区间结束值必须大于开始值");
            condition.rankEnd = "";
            isValid = false;
          }
        }
      }

      if (isValid && index > 0) {
        const prevCondition =
          this.prizeSetting[index - 1].scoreRankWinConditionDTO;
        const prevEnd =
          prevCondition.winType === 0
            ? Number(prevCondition.rankEnd)
            : Number(prevCondition.rankNum);

        if (prevEnd) {
          const currentStart = condition.winType === 0 ? rankStart : rankNum;
          if (currentStart && currentStart <= prevEnd) {
            this.$message.warning(
              `当前${condition.winType === 0 ? "区间开始值" : "指定名次"
              }必须大于前${prevCondition.winType === 0 ? "区间结束值" : "指定名次"
              }`
            );
            if (condition.winType === 0) {
              condition.rankStart = "";
            } else {
              condition.rankNum = "";
            }
            isValid = false;
          }
        }
      }

      if (isValid && index < this.prizeSetting.length - 1) {
        const nextCondition =
          this.prizeSetting[index + 1].scoreRankWinConditionDTO;
        const currentEnd = condition.winType === 0 ? rankEnd : rankNum;

        if (currentEnd) {
          const nextStart =
            nextCondition.winType === 0
              ? Number(nextCondition.rankStart)
              : Number(nextCondition.rankNum);
          if (nextStart && nextStart <= currentEnd) {
            this.$message.warning(
              `后${nextCondition.winType === 0 ? "区间开始值" : "指定名次"
              }必须大于当前${condition.winType === 0 ? "区间结束值" : "指定名次"
              }`
            );
            if (nextCondition.winType === 0) {
              nextCondition.rankStart = "";
            } else {
              nextCondition.rankNum = "";
            }
            this.prizeSetting[index + 1].totalAmount = null;
          }
        }
      }

      this.prizeSetting.forEach((prize, idx) => {
        const prizeCondition = prize.scoreRankWinConditionDTO;
        const prizeStart = Number(prizeCondition.rankStart);
        const prizeEnd = Number(prizeCondition.rankEnd);
        const prizeNum = Number(prizeCondition.rankNum);

        if (prizeCondition.winType === 0) {
          if (prizeStart && prizeEnd) {
            let total = prizeEnd - prizeStart + 1;
            prize.totalAmount = total > 0 ? total : null;
          } else if (prizeStart || prizeEnd) {
            prize.totalAmount = null;
          }
        } else if (prizeCondition.winType === 1) {
          prize.totalAmount = prizeNum > 0 ? 1 : null;
        }
      });
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    resetRgb(row, configJson) {
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
    },
    initCustomizeData(row) {
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.url2 = row.url2 || "";
      this.customerPaperwork.layout = row.layout || '1';
      // this.customerPaperwork.selectColor = row.rgb2 || "#ffffff";
      // this.customerPaperwork.unSelectBgColor = row.rgb3 || "#ffffff";
      // this.customerPaperwork.unSelectColor = configJson.rgb4 || "#ffffff";
      this.customerPaperwork.btnColor = row.rgb2 || "#ffffff";
      // this.customerPaperwork.navOpacity = +configJson.navOpacity || 100;
      this.resetRgb(row, configJson);
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
            return {
              ...item,
              days: item.activityStartTime
                ? this.getDaysBetween(
                  item.activityStartTime,
                  item.activityEndTime
                )
                : "",
            };
          })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        const configJson = this.templateObj.configJson
          ? JSON.parse(this.templateObj.configJson)
          : {};
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj, configJson);
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //生成规则
    generateRule() {
      let text1 = `活动时间范围内${this.activityStartTime} ~ ${this.activityEndTime}间，进入活动按要求提交晒单参与；`,
        text2 = `资料审核：需要商家审核，即上传晒单信息后需要等待商家审核通过后才算参与成功；`,
        text3 = `本活动自动获取参与用户在该店铺满足条件的评价，规则如下:\n`,
        text31 = `(1) 评价时间：${this.ruleForm.startCommentTime} ~ ${this.ruleForm.endCommentTime}；\n`,
        text32 = `(2) 评价门槛：${this.scores.map((item) => {
          let labelVal = ""
          this.labelVal.forEach((label) => {
            if (label.value == item) {
              labelVal = label.name
            }
          })
          return labelVal
        }).join("、")};\n`,
        text33 = `(3) 文字要求：${this.ruleForm.wordNum?`评论内容至少${this.ruleForm.wordNum}个字`:"评论内容不限字数"}\n`,
        text34 = `(4) 图片要求：${this.ruleForm.imgNum?`评论内容必须包含${this.ruleForm.imgNum}张图片`:"评论内容不限图片数量"}\n`,
        text35 = `(5) 视频要求：${this.ruleForm.videoNum?`评论内容必须包含${this.ruleForm.videoNum}个视频`:"评论内容不限视频数量"}\n`,
        text36 = `(6) 评价内容：${this.ruleForm.isCommentFilter?`不能包含${this.ruleForm.commentFilter}`:"无特殊约束"}\n`,
        text37 = `(7) 评价商品：只能评价${this.ruleForm.filterType == 0?"全店商品均可参与":"指定商品"}`,
        text4 = "排行榜结算：活动期间榜单实时按用户晒单累计点赞人数由高到低自动排序展示；",
        text5 = `入榜领奖条件：到达开奖时间${this.ruleForm.rankedOpenTiming}，${this.ruleForm.rankedOpenType == 0?`用户晒单点赞数需达到商家设置的最低入榜${this.ruleForm.rankedLimit}个点赞门槛，`:""}且排名落入对应奖品档位，方可获得对应档位奖品。`,
        text6 = `发奖规则：奖品份数发完即止，排名达标但奖品已发放完毕的用户无法获奖；相关问题可咨询店铺客服。`,

        text24 = `获奖条件：到达开奖时间${this.ruleForm.rankedOpenTiming}，排行榜展示商家标记的优质中奖晒单；`,
        text25 = `实物奖品发放规则：实物奖品将根据用户活动内预留的姓名、手机号、收货详细地址统一安排邮寄发放；用户未填写收货信息、填写信息无效或信息不全的，视为自动放弃中奖资格，奖品逾期不予补发。`,

        text7 = "活动奖品：\n",
        text8 = "礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；",
        text9 = "若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）;",
        // text7 =
        //   "如果是实物奖项，需填写收货地址后进行发货，且仅有一次填写地址机会，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会；",
        // text8 =
        //   "因平台订单接口限流，部分订单可能有所延迟，订单状态会持续更新，请耐心等待稍后再试；",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
      // let conditionText = "";
      // this.taskDataList.forEach((item, index) => {
      //   conditionText += `（${index + 1}）${useCondition(
      //     item,
      //     this,
      //     this.isShowCustom,
      //     "",
      //     this.mainText
      //   )}`;
      //   if (index < this.taskDataList.length - 1) {
      //     conditionText += "\n";
      //   }
      // });
      // if (this.taskDataList.length > 0) {
      //   text3 += "\n" + conditionText;
      // }
      this.prizeSetting.forEach((item, index) => {
        let prizeTittle = `第${item.scoreRankWinConditionDTO.winType == 0
          ? item.scoreRankWinConditionDTO.rankStart +
          "~" +
          item.scoreRankWinConditionDTO.rankEnd +
          "名"
          : item.scoreRankWinConditionDTO.rankNum + "名"
          }，`
        if(this.ruleForm.rankedOpenType == 1){
          prizeTittle = `${item.scoreRankWinConditionDTO.rankedTitle}:`
        }
        text7 += `（${index + 1}）${prizeTittle}可领取${item.title}，共${item.totalAmount ? item.totalAmount : 1}份${item.prizeType == 3 ? "，单份奖品价值" + item.price + "元" : ""
          }；${index != this.prizeSetting.length - 1 ? "\n" : ""}`;
      });
      // if (this.ruleDTO.participateType == 1) {
      //   text1 =
      //     "参与方式：活动期间内进入活动时自动判断用户身份，符合条件则自动报名；";
      // }
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      let pushTextArr = []
      if(this.ruleForm.rankedOpenType == 0){
        pushTextArr = [text4, text5, text6]
      }
      if(this.ruleForm.rankedOpenType == 1){
        pushTextArr = [text24, text25]
      }
      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3 + text31 + text32 + text33 + text34 + text35 + text36 + text37,  ...pushTextArr],
        [thirdText, text7, text8, text9],
        [fourthText, precautions],
      ];
      let newText = "";
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }

      if(!this.ruleForm.startCommentTime || !this.ruleForm.endCommentTime){
        return this.$message.warning("请完善评论时间");
      }
      if(this.ruleForm.filterType == 1){
        if(this.itemListForFilter.length == 0){
          return this.$message.warning("请选择参与商品");
        }
      }
      if(this.scores.length == 0){
        return this.$message.warning("请完善分数设置");
      }
      if(!this.ruleForm.imgNum || this.ruleForm.imgNum == '0'){
        return this.$message.warning("请输入评价图片数量");
      }
      if(this.ruleForm.isCommentFilter){
        if(!this.ruleForm.commentFilter){
          return this.$message.warning("请输入过滤条件");
        }
      }

      if(!this.ruleForm.rankedOpenTiming){
        return this.$message.warning("请选择开榜时间");
      }

      if(this.ruleForm.rankedOpenType == '0'){
        if(!this.ruleForm.rankedLimit){
          return this.$message.warning("请输入入榜限制");
        }
      }

      
      if (!useValidatePrizeInformation(this, "prizeSetting")) {
        return;
      }

      if(this.ruleForm.rankedOpenType == "1"){
        let isRank = false;
        this.prizeSetting.forEach((item) => {
          if(!item.scoreRankWinConditionDTO.rankedTitle){
            isRank = true;
          }
        })
        if(isRank){
          return this.$message.warning("请完善榜单条件");
        }
      }

      // if(){

      // }
    if(this.ruleForm.rankedOpenType == "0"){
      for (let i = 0; i < this.prizeSetting.length; i++) {
        const item = this.prizeSetting[i];
        const condition = item.scoreRankWinConditionDTO;

        if (condition.winType === 0) {
          const start = Number(condition.rankStart);
          const end = Number(condition.rankEnd);
          if (end <= start) {
            return this.$message.warning("区间结束值必须大于开始值");
          }
        }

        if (i > 0) {
          const prevItem = this.prizeSetting[i - 1];
          const prevCondition = prevItem.scoreRankWinConditionDTO;
          const prevEnd =
            prevCondition.winType === 0
              ? Number(prevCondition.rankEnd)
              : Number(prevCondition.rankNum);
          const currStart =
            condition.winType === 0
              ? Number(condition.rankStart)
              : Number(condition.rankNum);

          if (currStart <= prevEnd) {
            return this.$message.warning("排名设置需从上至下依次递增");
          }
        }
      }
    }

      if (!useValidateActEndInfomation(this)) {
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 奖品必选
      if (this.prizeSetting.some((item) => !item.prizeType)) {
        this.$message.warning("请至少选择一个奖品");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      const obj = initFrom(this);
      // 奖品处理
      let prizeListCommon = JSON.parse(JSON.stringify(this.prizeSetting));
      prizeListCommon = prizeListCommon.filter((item) => item.prizeType);
      obj.pointActivityPrizeDTOList = prizeListCommon;
      obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.map((item,index)=>{
        let prizedItem = {
          ...item,
          taskIndex: index,
        }
        return prizedItem;
      })
      // 任务
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          const params = useUpdateBasicInformation(obj, prizeListCommon, this);
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          saveOrUpdateShowImageGift(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getShowImageGiftDetail(this.valueRow.id)
          .then((res) => {
            console.log("--- ~ res:---", res)
            this.loading = false;
            const { pointActivityPrizeDTOList } = res.data;
            setBasicInformation(res.data, this);
            if (!this.activityData.isCopy) {
              // 奖品回显
              this.prizeSetting =
                pointActivityPrizeDTOList &&
                  pointActivityPrizeDTOList.length > 0
                  ? []
                  : [
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: null,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      singleAmount: "",
                      scoreRankWinConditionDTO: {
                        winType: 0, //排名类型
                        rankStart: "", //排名开始
                        rankEnd: "", //排名结束
                        rankNum: "", //指定名次
                        rankedTitle: "", //榜单名称
                      },
                    },
                  ];
                this.prizeSetting = pointActivityPrizeDTOList.map((item) => {
                  let newItem = {
                    ...item,
                    scoreRankWinConditionDTO:{
                        winType: 0, //排名类型
                        rankStart: "", //排名开始
                        rankEnd: "", //排名结束
                        rankNum: "", //指定名次
                        rankedTitle: "", //榜单名称
                    }
                  }
                  res.data.ruleDto.showImageStepList.forEach((step) => {
                    if (step.taskIndex == item.taskIndex) {
                      newItem.scoreRankWinConditionDTO = {
                        winType: step.rankedPrizeType,
                        rankStart: step.rankedPrizeStart,
                        rankEnd: step.rankedPrizeEnd,
                        rankNum: step.specifyRanking,
                        rankedTitle: step.rankedTitle,
                      }
                    }
                  })

                  return newItem
                })
            }
            // 任务回显
            // if (taskList.length > 0) {
            //   this.taskDataList = useOutputTaskData(taskList, this);
            // }
            this.getPolite();
          })
          .catch((res) => { });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }

  .showTip {
    color: red;
    font-size: 14px;
  }

  .openTip {
    margin-left: 8px;
    color: #333333;
  }

  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }

  .upload-box {
    width: 450px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}

.w80 {
  width: 80px;
}

.w200 {
  width: 200px;
}

.w60 {
  width: 60px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}

.flex-r {
  display: flex;
  align-items: center;
}

/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
